// import Typewriter from 'typewriter-effect/dist/core';
import { init } from 'ityped'
export default {
    init() {
        let typewriterElement = document.querySelector('.header--contact .header__text');
        if(typewriterElement) {
            if(!typewriterElement.dataset.typewriterTitles) {
                throw new Error('ContactHeader.js - missing typewriter titles.')
            }

            let titles = JSON.parse(typewriterElement.dataset.typewriterTitles);
            init(typewriterElement, {
                showCursor: true,
                strings: titles,
                loop: true,
                backDelay: 2000,
            });
            // let typewriter = new Typewriter(typewriterElement, {
            //     strings: titles,
            //     autoStart: true,
            //     loop: true,
            // });
        }
    }
}